// Navegación desde las filas de un reporte a la pantalla de detalle del movimiento o de la cesión.
// La fila debe traer `record_id` (id numérico) y, si mezcla ambos, `record_type` ('movement' | 'assignment').
export default {
  methods: {
    openRecord (row, type) {
      if (!row || !row.record_id) return
      const kind = type || row.record_type
      if (kind === 'assignment') {
        this.$router.push({ name: 'CesionDetail', params: { cesion_id: row.record_id } })
      } else {
        this.$router.push({ name: 'MovimientoDetail', params: { movimiento_id: row.record_id } })
      }
    }
  }
}
